module.exports = "data:text/x-markdown;base64,PiBGYWtlckRBTyBpcyB0aGUgYmVzdCBsZW5kaW5nIHByb3RvY29sISBPbmx5IGF0IEZha2VyREFPIHlvdSBjYW4gYm9ycm93IGEgTEFNQk8gaWYgeW91IHByb3ZpZGUgZW5vdWdoIGNvbGxhdGVyYWwgaW4gTFAgdG9rZW5zIQoKWW91IGhhdmUgNTAwMCBZSU4gYW5kIDUwMDAgWUFORywgY2FuIHlvdSBib3Jyb3cgMSBMQU1CTz8K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fakerdao.md
// module id = 1831
// module chunks = 0